import React from 'react'
import styles from "./Main.module.css";
import { Link } from 'react-router-dom';

import GetHeader from '../helper/getHeader/GetHeader';
import bg_main_1 from '../../../assets/dashboard/bg_main_1.png'
import bg_main_2 from '../../../assets/dashboard/bg_main_2.png'
import bg from '../../../assets/dashboard/background.png'
import medal from '../../../assets/dashboard/medal.png'
import logo_big from '../../../assets/dashboard/logo_big.png'

const Main = ({ }) => {

    return (
        <div
            className={styles.wrapper}>
            <img src={bg} className={styles.bg} />
            <div className={styles.logo_bigWrapper}>
                <img src={logo_big} className={styles.logo_big} />

            </div>
            <GetHeader title={<>СЕТЬ ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ ВЫСШЕГО ОБРАЗОВАНИЯ <br /> МИНОБОРОНЫ РОССИИ</>} />

            <div className={styles.wrapperBlock}>
                <Link
                    to="/dashboard/indicators"
                    className={styles.blockItem}>
                    <img src={bg_main_1} className={styles.card} />
                    <p>Показатели деятельности системы высшего военного образования</p>
                </Link>
                <Link
                    to="/dashboard/list"
                    className={styles.blockItem}
                >
                    <img src={bg_main_2} className={styles.card} />
                    <p>Показатели деятельности Военных ВУЗов</p>
                    {/* <img 
            src={medal}
            className={styles.medal}/> */}
                </Link>
            </div>
        </div>
    )
}

export default Main